module.exports = __webpack_public_path__ + "img/frittata-thumb.ce8baad0.png";